import React from 'react'
import styled from 'styled-components'

const ShareButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0px;
  font: inherit;
  color: inherit;
  cursor: pointer;
  img {
    transition: 0.3s ease;
    cursor: pointer;
    width: 35px;
    height: 35px;
    text-align: center;
    display: block;
    @media (max-width: 640px) {
      width: 28px;
      height: 28px;
    }
    &:hover {
      opacity: 0.4;
    }
  }
`

const XShareButton = (props: { 
  url: string
  title?: string
  beforeOnClick?: Function
  children: React.ReactNode
}) => {
  const { title, url, beforeOnClick, children } = props
  const tweetUrl = 'https://twitter.com/intent/tweet'
  
  const tweet = (e:any) => {
    e.preventDefault()
    if(beforeOnClick) beforeOnClick()
    const text = `${title}`
    const _url = `${url}\n#YOOR`
    let urlWithParams = `${tweetUrl}?url=${encodeURIComponent(_url)}&text=${encodeURIComponent(text)}`
    window.open(
      urlWithParams,
      '_blank',
      'width=550,height=400,noopener,noreferrer'
    )
  }

  return (
    <ShareButton onClick={tweet} className='share-link'>
      {children}
    </ShareButton>
  )
};

export default XShareButton